module.exports = __webpack_public_path__ + "img/import-area.7e2cd95.png";